import AddEditPart from '../../AddEditPart'
import useCreatePartHandler from '../../../effects/create-part'
import { heapEvent } from '@equipmentshare/heaper'

export type AddPartProps = {
  onCancel: () => void,
  onSuccess: () => void,
}

export default function AddPartModal( { onCancel, onSuccess }: AddPartProps ) {
	const createPart = useCreatePartHandler()

	const handleSubmit = async( partArgs: any ) => {
		heapEvent( 'Inventory - Add Part Modal - Click - Submit', {} )
		return await createPart( partArgs )
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Add Part Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<AddEditPart
			onCancel={handleCancel}
			onSubmit={handleSubmit}
			onSuccess={onSuccess}
		/>
	)
}
